import React, {type ReactNode} from 'react';

import {Group, Item} from '@pb/kit-component-group';
import Label from '@pb/kit-component-label';

type Props = {
    caption: string,
    children: ReactNode,
    width?: number,
};

const DEFAULT_LABEL_WIDTH = 120;
export const SwitcherLabel = ({caption, children, width = DEFAULT_LABEL_WIDTH}: Props) => (
    <Group>
        <Item style={{width}}>
            <Label {...{caption}}/>
        </Item>
        {children}
    </Group>
);
